import { configureStore } from "@reduxjs/toolkit";
import { openBankingReducer, OPENBANKING_FEATURE_KEY } from "./openBanking";
import { uiReducer, UI_FEATURE_KEY } from "./ui/ui.slice";
import { recoveryReducer, RECOVERY_FEATURE_KEY } from "./recovery";
import { QR_LOGIN_FEATURE_KEY, qrLoginReducer } from "./qrLogin";
import { modalReducer, ERROR_MODAL_FEATURE_KEY } from "./modal";
import { countriesReducer, COUNTRIES_FEATURE_KEY } from "./countries";
import { registrationReducer, REGISTRATION_FEATURE_KEY } from "./registration";
import { legalUserReducer, LEGAL_USER_FEATURE_KEY } from "./legalUser";


const store = configureStore({
	reducer: {
		[UI_FEATURE_KEY]: uiReducer,
		[RECOVERY_FEATURE_KEY]: recoveryReducer,
		[OPENBANKING_FEATURE_KEY]: openBankingReducer,
		[QR_LOGIN_FEATURE_KEY]: qrLoginReducer,
		[ERROR_MODAL_FEATURE_KEY]: modalReducer,
		[COUNTRIES_FEATURE_KEY]: countriesReducer,
		[REGISTRATION_FEATURE_KEY]: registrationReducer,
		[LEGAL_USER_FEATURE_KEY]: legalUserReducer,
	},
	// Additional middleware can be passed to this array
	middleware: (getDefaultMiddleware) => getDefaultMiddleware(),
	devTools: process.env.NODE_ENV !== "production",
	// Optional Redux store enhancers
	enhancers: [],
});

export type StoreState = ReturnType<typeof store.getState>;
export type DispatchType = typeof store.dispatch;

export default store;

export * from "./recovery";
export * from "./ui";
export * from "./openBanking";
export * from "./modal";
export * from "./countries";
export * from "./registration";
export * from "./legalUser";

